module.exports = __webpack_public_path__ + "img/manda_041.c60c9919.png";